import Vue from 'vue'
import 'windi.css'
import '@/theme/element.scss'
/* import VCharts from 'v-charts' */
import ElementUI from 'element-ui'
import 'element-theme-chalk/src/reset.scss'
import App from './App.vue'
import store from '@/store'
import Router from 'vue-router'
import router from '@/routes'
import '@/utils/directives'
import { logError } from '@/utils/log'
import OssUploader from '@/components/OssUploader'
import BlockHeader from '@/components/BlockHeader'
import PageHeader from '@/components/PageHeader'
import LoadSelect from '@/components/LazyLoadingSelect'
import InputTopTip from '@/components/InputTopTip'
import { reqfb as RequestFeedback } from '@/components/RequestFeedback'
import moment from 'moment'
import MediaRecorder from 'audio-recorder-polyfill'
import { GET_SERVER_CONFIG } from '@/store/actions'
import { Message } from 'element-ui'
import { createFilePreview } from '@/extends/filePreview'
import '@/assets/icons/index' //./assets/icons/index
// 引入echarts
import * as echarts from 'echarts'
// import VueKonva from 'vue-konva';
// 设置全局 echarts
Vue.prototype.$echarts = echarts
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import ApiClient from '@midipro/js-api'
import { http, request } from '@/api'

import { permissions } from '@/utils/directives.js'
import 'file-explorer/dist/file-explorer.css'

// 安装插件
Vue.use(ElementUI)
Vue.use(Router)

// 注册全局组件
Vue.component('oss-uploader', OssUploader)
Vue.component('block-header', BlockHeader)
Vue.component('page-header', PageHeader)
Vue.component('load-select', LoadSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('InputTopTip', InputTopTip)

// 配置转换过滤器
Vue.filter('dateonly', value => moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD'))

Vue.filter('duration', value => {
	if (!value) return value

	if (value < 60) {
		return value + '秒'
	} else if (value < 3600) {
		return parseInt(Math.floor(value / 60)) + '分' + (value % 60) + '秒'
	} else {
		return (
			parseInt(Math.floor(value / 3600)) +
			'小时' +
			parseInt(Math.floor((value % 3600) / 60)) +
			'分' +
			(value % 60) +
			'秒'
		)
	}
})

// 全屏答题下需要hook住element弹窗api特殊处理，这里存一下
Vue.prototype.$originalElementMessage = Vue.prototype.$message
Vue.prototype.$originalElementAlert = Vue.prototype.$alert
Vue.prototype.$originalElementConfirm = Vue.prototype.$confirm
Vue.prototype.$createFilePreview = createFilePreview
Vue.prototype.$permissions = permissions
Vue.prototype.$http = http
Vue.prototype.$request = request
Vue.prototype.$api = new ApiClient({
	// 'app-name': 'web-back-stage-management',
	// 'app-version': '1.4.6',
	handlers: {
		onStart(target) {
			RequestFeedback.start(target)
		},
		onFail(target, error) {
			RequestFeedback.fail(target)
		},
		onSuccess(target) {
			RequestFeedback.finish(target)
		},
		onErrorPrompt(message) {
			Message({
				message,
				type: 'error',
				duration: 5000
			})
		}
	}
})
Vue.prototype.$api2 = new ApiClient({
	// 'app-name': 'web-back-stage-management',
	// 'app-version': '1.4.5',
	handlers: {
		// onStart(target) {
		// 	RequestFeedback.start(target)
		// },
		// onFail(target, error) {
		// 	RequestFeedback.fail(target)
		// },
		// onSuccess(target) {
		// 	RequestFeedback.finish(target)
		// },
		onErrorPrompt(message) {
			Message({
				message,
				type: 'error',
				duration: 5000
			})
		}
	}
})

Vue.prototype.$api3 = new ApiClient({
	timeout: 1000000000,
	handlers: {
		onErrorPrompt(message) {
			Message({
				message,
				type: 'error',
				duration: 5000
			})
		}
	}
})

Vue.prototype.$api4 = new ApiClient({
	timeout: 5000,
})

Vue.prototype.$api5 = new ApiClient({
	timeout: 1000000000,
	handlers: {
	}
})

console.warn('接口', Vue.prototype.$api)
// MediaRecorder 垫片
if (!window.MediaRecorder) {
	window.MediaRecorder = MediaRecorder
}

// 限制特殊字符
Vue.prototype.validForbid = function (value) {
	value = value
		.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '')
		.replace(/\s/g, '')
	return value
}

// 恢复一些状态到vuex
store.commit('restore')
// 获取当前站点配置信息（例如名称，logo 之类的）
store.dispatch(GET_SERVER_CONFIG)

const appRoot = new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
})

// 全局MixIn，处理activated/deactivated
Vue.mixin({
	data() {
		return {
			$_compActivated: true
		}
	},
	activated() {
		this.$_compActivated = true
	},
	deactivated() {
		this.$_compActivated = false
	},
	methods: {
		isComponentActivated() {
			return this.$_compActivated
		}
	}
})

Vue.config.errorHandler = (err, vm, info) => {
	const params = {
		type: 'vue_error',
		message: err.message,
		stack: err.stack,
		vnode: vm.$vnode?.tag,
		component: vm?.$options?.name, // 组件名称
		info: info, // Vue 特定错误信息（如生命周期钩子）
		route: vm?.$route?.path // 当前路由（需 Vue Router）
	}
	logError(params)
}

history.pushState({ notAllowBack: true }, null, window.location.href)

window.top.alert = console.error

export default appRoot
